// Combined storefront embed bundle — single entry point.
//
// Ships as ONE minified public/js/storefront.js (built by ../build-embeds.mjs) and
// is included ONCE per storefront page via a single <script> tag. Each widget is a
// module that self-detects whether its target elements exist on the current page
// and no-ops otherwise, so the one bundle is safe to load site-wide.
//
// Adding a widget: create embeds/widgets/<name>.js exporting `init()` (and an `id`),
// then register it in WIDGETS below. Config comes from the widget's TARGET element,
// never from the script tag (there's only one tag now).

import { isContentEditor, onReady } from './shared/dom.js';

import * as accountMenu from './widgets/account-menu.js';
import * as checkoutCredit from './widgets/checkout-credit.js';
import * as additionalInfo from './widgets/additional-info.js';
import * as alternativeProducts from './widgets/alternative-products.js';
import * as suggestedProducts from './widgets/suggested-products.js';
import * as vehicleAttributes from './widgets/vehicle-attributes.js';
import * as branchOnHand from './widgets/branch-on-hand.js';
import * as brandsDropdown from './widgets/brands-dropdown.js';
import * as counterParts from './widgets/counter-parts.js';
import * as creditGuard from './widgets/credit-guard.js';
import * as departmentLinks from './widgets/department-links.js';
import * as departmentsSlider from './widgets/departments-slider.js';
import * as garageCount from './widgets/garage-count.js';
import * as generateQuoteButton from './widgets/generate-quote-button.js';
import * as guidedTours from './widgets/guided-tours.js';
import * as quotesList from './widgets/quotes-list.js';
import * as returnsList from './widgets/returns-list.js';
import * as hideHeadOffice from './widgets/hide-head-office.js';
import * as storeLocatorUrls from './widgets/store-locator-urls.js';
import * as wishlistComingSoon from './widgets/wishlist-coming-soon.js';
import * as compareComingSoon from './widgets/compare-coming-soon.js';
import * as logReturnButton from './widgets/log-return-button.js';
import * as logReturnForm from './widgets/log-return-form.js';
import * as logReturnPaymentSuccess from './widgets/log-return-payment-success.js';
import * as myGarage from './widgets/my-garage.js';
import * as oemCodes from './widgets/oem-codes.js';
import * as oilGuide from './widgets/oil-guide.js';
import * as partsSearch from './widgets/parts-search.js';
import * as presentationMode from './widgets/presentation-mode.js';
import * as partsSlider from './widgets/parts-slider.js';
import * as productPrice from './widgets/product-price.js';
import * as vehicleCompatibility from './widgets/vehicle-compatibility.js';
import * as vehicleMakesDropdown from './widgets/vehicle-makes-dropdown.js';
import * as vehicleSelector from './widgets/vehicle-selector.js';
import * as videos from './widgets/videos.js';
import * as wolfOilGuide from './widgets/wolf-oil-guide.js';

var WIDGETS = [
  // Global (no container) — gates, menu patches, cart/branch behaviour.
  creditGuard,
  hideHeadOffice,
  storeLocatorUrls,
  wishlistComingSoon,
  compareComingSoon,
  accountMenu,
  checkoutCredit,
  garageCount,
  partsSearch,
  presentationMode,
  departmentLinks,
  logReturnButton,
  logReturnForm,
  logReturnPaymentSuccess,
  generateQuoteButton,
  quotesList,
  returnsList,
  // Product-detail widgets (keyed off a container + SKU).
  additionalInfo,
  oemCodes,
  videos,
  vehicleCompatibility,
  vehicleAttributes,
  counterParts,
  alternativeProducts,
  suggestedProducts,
  branchOnHand,
  productPrice,
  // Navigation / discovery.
  brandsDropdown,
  vehicleMakesDropdown,
  vehicleSelector,
  departmentsSlider,
  myGarage,
  // Sliders + oil guides (iframe / third-party plugin).
  partsSlider,
  oilGuide,
  wolfOilGuide,
  // Guided tours last — they spotlight elements the widgets above render.
  guidedTours,
];

function runAll() {
  // Never run inside the OE Commerce content editor / backoffice.
  if (isContentEditor()) return;
  for (var i = 0; i < WIDGETS.length; i++) {
    var w = WIDGETS[i];
    try {
      if (w && typeof w.init === 'function') w.init();
    } catch (e) {
      try { console.warn('storefront embeds: widget "' + ((w && w.id) || i) + '" init failed', e); } catch (_) { /* ignore */ }
    }
  }
}

onReady(runAll);
